// Grid density switcher for the collection page. Columns are set as CSS variables on the
// .pbuw-collection wrapper, which facets.js never re-renders, so the choice survives filtering.
if (!customElements.get('pbuw-view-toggle')) {
  class PbuwViewToggle extends HTMLElement {
    connectedCallback() {
      this.target = this.closest('.pbuw-collection');
      if (!this.target) return;

      this.storageKey = this.dataset.storageKey || 'pbuw-collection-view';
      this.state = {
        desktop: parseInt(this.dataset.defaultDesktop, 10),
        mobile: parseInt(this.dataset.defaultMobile, 10),
      };

      try {
        const saved = JSON.parse(window.localStorage.getItem(this.storageKey)) || {};
        ['desktop', 'mobile'].forEach((device) => {
          if (this.hasOption(device, saved[device])) this.state[device] = saved[device];
        });
      } catch (error) {
        // Storage can be unavailable (private mode); fall back to the section defaults.
      }

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cols]');
        if (!button) return;
        this.state[button.dataset.device] = parseInt(button.dataset.cols, 10);
        this.apply();
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(this.state));
        } catch (error) {
          // Ignore storage failures; the change still applies for this page view.
        }
      });

      this.apply();
    }

    hasOption(device, cols) {
      return Boolean(cols && this.querySelector(`[data-device="${device}"][data-cols="${cols}"]`));
    }

    apply() {
      const { desktop, mobile } = this.state;
      this.target.style.setProperty('--pbuw-cols-desktop', desktop);
      this.target.style.setProperty('--pbuw-cols-tablet', Math.min(desktop, 3));
      this.target.style.setProperty('--pbuw-cols-mobile', mobile);

      this.querySelectorAll('[data-cols]').forEach((button) => {
        const pressed = parseInt(button.dataset.cols, 10) === this.state[button.dataset.device];
        button.setAttribute('aria-pressed', String(pressed));
      });
    }
  }

  customElements.define('pbuw-view-toggle', PbuwViewToggle);
}
